module.exports = __webpack_public_path__ + "media/assets/faria_products/PEA-IGCSE-5e0ce3af93daa7072f737140c064251451d5ce73e3869c8f8c143e1f7427084f.svg";